<template>
  <div>
    <v-snackbar v-model="snackbar" :timeout="snackbar_timeout" :color="snackbar_color" :top="true">
      {{ snackbar_message }}
    </v-snackbar>

    <v-card flat class="mt-5">
      <v-card-title>
        <h6 class="primary--text">Liste des maillons</h6>
        <v-spacer></v-spacer>

        <v-btn rounded color="primary" class="text-capitalize" v-if="$can('create maillons')">
          <export-excel :data="maillons" name="Maillons.xls" :export-fields="maillons_fields">
            Exporter
            <v-icon right>mdi-share-outline</v-icon>
          </export-excel>
        </v-btn>
        <v-spacer></v-spacer>

        <v-dialog v-model="dialog_edit" max-width="500px">
          <template v-slot:activator="{ on }">
            <v-btn rounded color="primary" dark class="mb-2" v-on="on" v-if="$can('create maillons')">
              Ajouter <v-icon right>mdi-plus-circle-outline</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12 md12>
                    <v-text-field v-model="editedItem.name" label="Nom du maillon" solo></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 md12>
                    <v-autocomplete v-model="editedItem.actor_type_id" :items="actor_types" item-text="name"
                      item-value="id" label="Type d'acteur" clearable solo></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="info" rounded @click="dialog_edit = false">Fermer</v-btn>
              <v-btn color="primary" :loading="load" :disabled="load" rounded @click="save">Enregistrer</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-spacer></v-spacer>

        <v-text-field v-model="search" append-icon="mdi-magnify" label="Rechercher un maillon" single-line solo
          hide-details>
        </v-text-field>
      </v-card-title>
    </v-card>

    <v-data-table v-if="maillons" :headers="headers" :items="maillons" :loading="loading" loading-text="Loading..."
      sort-by="name" :search="search" class="elevation-1">
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" v-if="$can('edit maillons')">
          mdi-pencil-outline
        </v-icon>
        <v-icon small @click="deleteItem(item)" v-if="$can('delete maillons')">
          mdi-trash-can-outline
        </v-icon>
      </template>
    </v-data-table>

    <v-layout row justify-center>
      <v-dialog v-model="dialog_deletion" max-width="290">
        <v-card>
          <v-card-title class="headline">Suppression</v-card-title>
          <v-card-text class="text-center">
            Etes-vous sûr de vouloir supprimer ce maillon ?
          </v-card-text>
          <v-card-actions>
            <v-btn color="orange" rounded @click="dialog_deletion = false">
              <span class="white-couleur">Non</span>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="success" :loading="load" :disabled="load" rounded @click="delMaillon()">
              Oui
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import Permissions from '~/mixins/Permissions';

export default {
  name: 'settings-maillon',
  mixins: [Permissions],
  data: () => ({
    del_maillon: null,
    del_index: null,
    search: '',
    loading: false,
    load: false,
    dialog_edit: false,
    dialog_deletion: false,
    headers: [
      { text: 'Maillon', value: 'name' },
      { text: 'Type d\'acteur', value: 'actor_type.name' },
      { text: 'Actions', value: 'action', sortable: false }
    ],
    maillons_fields: {
      "Maillon": "name",
      "Type d\'acteur": "actor_type.name",
    },
    snackbar: false,
    snackbar_message: '',
    snackbar_timeout: 5000,
    snackbar_color: '',

    editedIndex: -1,
    editedItem: {
      name: '',
      country_id: null,
    },
    defaultItem: {
      name: '',
      country_id: null,
    },

  }),

  created() {
    this.loading = true
    this.fetchUtils();
    this.loading = false
  },

  computed: {
    actor_types() { return this.$store.getters.actor_types; },
    maillons() { return this.$store.getters.maillons; },
    formTitle() {
      return this.editedIndex === -1 ? 'Nouveau maillon' : 'Editer le maillon'
    },
  },

  watch: {
    dialog(val) {
      val || this.close()
    },
  },

  methods: {
    fetchUtils() {
      this.$store.dispatch("fetchActorTypes");
      this.$store.dispatch("fetchMaillons");
    },

    editItem(item) {
      this.editedIndex = this.maillons.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_edit = true
    },

    deleteItem(item) {
      this.del_index = this.maillons.indexOf(item);
      this.dialog_deletion = true;
      this.del_maillon = item;
    },

    close() {
      this.dialog_edit = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save() {
      this.load = true;
      if (this.editedIndex > -1) {
        await this.$store.dispatch("updateMaillon", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Maillon édité avec succès !";
      }
      else {
        await this.$store.dispatch("createMaillon", this.editedItem);
        this.snackbar = true;
        this.snackbar_color = 'success';
        this.snackbar_message = "Maillon enregistré avec succès !";
      }
      this.close();
      this.load = false;
    },

    async delMaillon() {
      this.load = true;
      await this.$store.dispatch("deleteMaillon", this.del_maillon);
      this.dialog_deletion = false;
      this.snackbar = true;
      this.snackbar_color = 'success';
      this.snackbar_message = "Maillon supprimé avec succès !";
      this.load = false;
    },

  }
};
</script>

<style scoped>
.white-couleur {
  color: white;
}
</style>




// WEBPACK FOOTER //
// resources/assets/js/pages/settings/maillons/list.vue